module.exports = "<script type=\"text/html\" id=\"survey-string\">\n    <!-- ko component: { name: renderAs, params: { locString: $data } } -->\n    <!-- /ko -->\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/string.html
// module id = 152
// module chunks = 0